/**
 * Dealer Profile analytics event names (Dealer Profile M13).
 */

export const DEALER_PROFILE_ANALYTICS_EVENTS = {
  PROFILE_VIEWED: "dealer_profile_viewed",
  UNAVAILABLE_VIEWED: "dealer_profile_unavailable_viewed",
  NOT_FOUND_VIEWED: "dealer_profile_not_found_viewed",
  ERROR_VIEWED: "dealer_profile_error_viewed",

  INVENTORY_VIEWED: "dealer_inventory_viewed",
  INVENTORY_EMPTY_VIEWED: "dealer_inventory_empty_viewed",
  INVENTORY_ERROR_VIEWED: "dealer_inventory_error_viewed",
  INVENTORY_CARD_CLICKED: "dealer_inventory_card_clicked",

  INVENTORY_FILTER_CHANGED: "dealer_inventory_filter_changed",
  INVENTORY_FILTER_REMOVED: "dealer_inventory_filter_removed",
  INVENTORY_FILTERS_CLEARED: "dealer_inventory_filters_cleared",
  INVENTORY_SORT_CHANGED: "dealer_inventory_sort_changed",
  INVENTORY_FILTER_DRAWER_OPENED: "dealer_inventory_filter_drawer_opened",
  INVENTORY_FILTER_DRAWER_CLOSED: "dealer_inventory_filter_drawer_closed",

  TRUST_PANEL_VIEWED: "dealer_trust_panel_viewed",
  CHECKLIST_CLICKED: "dealer_profile_checklist_clicked",

  MOBILE_CTA_CLICKED: "dealer_profile_mobile_cta_clicked",
  MOBILE_CTA_WHATSAPP_CLICKED: "dealer_profile_mobile_cta_whatsapp_clicked",
  MOBILE_CTA_PHONE_CLICKED: "dealer_profile_mobile_cta_phone_clicked",
};

export const DEALER_PROFILE_ANALYTICS_SOURCE_COMPONENTS = {
  PUBLIC_PAGE: "public_dealer_profile_page",
  HERO: "dealer_profile_hero",
  TRUST_PANEL: "dealer_profile_trust_panel",
  MOBILE_CTA: "dealer_profile_mobile_cta",
  INVENTORY_GRID: "dealer_inventory_grid",
  INVENTORY_CARD: "dealer_inventory_card",
  INVENTORY_FILTERS: "dealer_inventory_filters",
  INVENTORY_SORT: "dealer_inventory_sort",
  MOBILE_FILTERS: "dealer_inventory_mobile_filters",
};

/** Safe disabled-contact categories for analytics (no moderation detail). */
export const DEALER_PROFILE_DISABLED_REASON_CATEGORIES = {
  DEALER_UNAVAILABLE: "dealer_unavailable",
  CONTACT_MISSING: "contact_missing",
  CONTACT_INVALID: "contact_invalid",
  LISTING_UNAVAILABLE: "listing_unavailable",
  UNKNOWN: "unknown",
};

/** Safe lead failure categories for analytics. */
export const DEALER_PROFILE_LEAD_ERROR_CATEGORIES = {
  NETWORK_ERROR: "network_error",
  VALIDATION_ERROR: "validation_error",
  SERVICE_UNAVAILABLE: "service_unavailable",
  DUPLICATE_SUPPRESSED: "duplicate_suppressed",
  UNKNOWN: "unknown",
};
